import { css } from "@emotion/react";
import logo from "../../../../../assets/img/flowio-ikona.svg";

export const logoContainerCss = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 110px;
  height: 70px;

  display: flex;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 990px) {
    display: none;
  }
`;

export const logoCss = css`
  position: fixed;
  background-image: url(${logo});
  background-size: contain;
  //padding: 10px 20px 10px 10px;
  background-repeat: no-repeat;
  background-position: left;
  height: 50px;
  width: 60px;
  border-right: 1px solid #c0c6d0;

  white-space: normal;
  text-align: center;
`;
